import { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { initGA, logPageView } from '../../init/google-analytics';
import Header from '../header';
import Footer from '../footer';
import CookieAlert from '../cookie-alert';
import { Container } from './styled';

export default class Layout extends Component {
  componentDidMount() {
    if (!window.GA_INITIALIZED) {
      initGA();
      window.GA_INITIALIZED = true;
    }
    logPageView();
  }

  render() {
    const { children } = this.props;

    return (
      <Container>
        <Head>
          <title>
            EyeFitU | AI-Powered Size & Fit Solutions for Fashion & Footwear
          </title>
          <meta
            name="description"
            content="Reduce returns, boost conversions, and improve customer experience with EyeFitU's patented AI sizing technology for apparel and footwear."
          />
          <meta
            name="keywords"
            content="AI sizing solution, fashion tech, fit recommendation software, reduce returns, apparel size chart, size-as-a-service, EyeFitU, ecommerce returns, size widget, virtual fitting, smart size recommender"
          ></meta>
          <link rel="shortcut icon" href="/images/favicon.ico" />
          <link rel="canonical" href="https://www.eyefitu.com/" />
          <meta property="og:locale" content="en_US" />
          <meta
            property="og:title"
            content="EyeFitU | AI-Powered Size & Fit Solutions for Fashion & Footwear"
          />
          <meta
            property="og:description"
            content="AI-driven platform helping fashion retailers improve sizing accuracy, boost AOV, and reduce returns."
          />
          <meta
            property="og:image"
            content="https://www.eyefitu.com/images/svg/logo-colored.svg"
          />
          <meta property="og:url" content="https://www.eyefitu.com/" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="EyeFitU" />
          <meta
            name="google-site-verification"
            content="N132qDv2Z6cft9-1vP4x5AkpmhFbwZQ13zoooDnGwVo"
          />
          <meta
            name="google-site-verification"
            content="jNhor7BMMRvH8vAoBCAd8m9ai9wgFV-D3bRH742MRi8"
          />
          <meta
            name="verification"
            content="0306c88b7d42e8c86d0e9636621b9a3b"
          />
          <meta name="viewport" content="width=device-width, initial-scale=1" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="EyeFitU | AI-Powered Size & Fit Solutions for Fashion & Footwear"
          />
          <meta
            name="twitter:description"
            content="AI-driven platform helping fashion retailers improve sizing accuracy, boost AOV, and reduce returns."
          />
          <meta name="twitter:site" content="@eyefitu" />
        </Head>
        <Header />
        {children}
        <Footer />
        <CookieAlert />
      </Container>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
